document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('[data-fw-nav-dropdown]');

  dropdowns.forEach((dropdown) => {
    const trigger = dropdown.querySelector(':scope > [data-fw-nav-trigger]');
    const submenu = dropdown.querySelector(':scope > [data-fw-nav-submenu]');

    if (!trigger || !submenu) return;

    const setExpanded = (expanded) => {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      dropdown.classList.toggle('is-open', expanded);
    };

    const openDropdown = () => {
      dropdown.classList.remove('is-force-closed');
      setExpanded(true);
    };

    const closeDropdown = (forceClosed = false) => {
      setExpanded(false);
      dropdown.classList.toggle('is-force-closed', forceClosed);
    };

    dropdown.addEventListener('mouseenter', openDropdown);

    dropdown.addEventListener('mouseleave', () => {
      if (!dropdown.contains(document.activeElement)) {
        closeDropdown(false);
      }
    });

    dropdown.addEventListener('focusin', () => {
      if (!dropdown.classList.contains('is-force-closed')) {
        openDropdown();
      }
    });

    dropdown.addEventListener('focusout', () => {
      window.requestAnimationFrame(() => {
        if (!dropdown.contains(document.activeElement)) {
          closeDropdown(false);
          dropdown.classList.remove('is-force-closed');
        }
      });
    });

    trigger.addEventListener('keydown', (event) => {
      if (event.key === ' ') {
        event.preventDefault();

        const expanded = trigger.getAttribute('aria-expanded') === 'true';

        if (expanded) {
          closeDropdown(true);
        } else {
          openDropdown();
        }
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDropdown(true);
        trigger.focus();
      }
    });

    submenu.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      event.preventDefault();
      closeDropdown(true);
      trigger.focus();
    });
  });
});
